import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm3.296-15.14-.86-.86-3.546 3.547 3.547 3.546.859-.86-2.088-2.087h4.968V8.93h-4.951l2.071-2.07Zm-2.11 7.593-3.548-3.546-.859.86 2.088 2.087H5.9v1.216h4.95l-2.07 2.07.858.86 3.547-3.547Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
